<template>
<main class="l-contents mt-4">
  <div class="title1 text-center">
    <h2 class="title1_title"><span class="title1_mainLabel" v-t="'tokuhoso.title'"></span></h2>
  </div>
  <div class="mt-3" v-t="'translatedByMachine'"></div>
  <table class="tokuhoso">
    <tr v-for="i in 11" :key="i">
      <th class="t-title">{{ $t('tokuhoso.table.title_' + i) }}</th>
      <td v-if="i === 7" class="sub-content"><a :href="$t('tokuhoso.table.content_' + i)" target="_blank">{{$t('tokuhoso.table.content_' + i)}}</a></td>
      <td v-else-if="i === 6" class="sub-content"><a :href="'mailto:' + $t('tokuhoso.table.content_' + i)">{{$t('tokuhoso.table.content_' + i)}}</a></td>
      <td v-else-if="i === 10" class="sub-content">{{ $t('tokuhoso.table.content_' + i) }}<br>
          <img src="../../../assets/images/visa.png" style="height:40px">
          <img src="../../../assets/images/master.png" style="height:40px">
          <img src="../../../assets/images/jcb.png" style="height:40px">
          <img src="../../../assets/images/amex.png" style="height:40px">
          <img src="../../../assets/images/diners.png" style="height:40px">
      </td>
      <td v-else class="sub-content">{{$t('tokuhoso.table.content_' + i)}}</td>
    </tr>
  </table>
</main>
</template>

<script>
export default {
  name: 'Tokuhoso'
}
</script>

<style>
table.tokuhoso, th, td {
  border: 1px solid #b3b3b3;
  padding: 10px;
}

th.t-title {
  background-color: rgb(232, 232, 232);
}
</style>
